module.exports = __webpack_public_path__ + "static/media/Logo_Icon.88d03bee.svg";